export default "__VITE_ASSET__CNtzh9oM__"